import React, { useState } from 'react';

import { FormSubmitButton } from '../../../components/Button/FormSubmitButton';
import { Modal } from '../../../components/Modal/Modal';
import TripLogModal from '../../../components/Modal/ModalActions/TripLogModal/TripLogModal';
import Table from '../../../components/Table/Table';
import TableDateFormatter from '../../../components/Table/TableAccessories/TableDateFormatter';
import TableDateTimeFormatter from '../../../components/Table/TableAccessories/TableDateTimeFormatter';
import TripLogCell from '../../../components/Table/TableMobileRowCell/TripLogCell';
import LogManagement from './LogManagement';

const TripLogTables = () => {
  const [tableRefreshKey, setTableRefreshKey] = useState(0);
  const [showCreateTripLogModal, setShowCreateTripLogModal] = useState(false);

  const onSubmitCreateTripLog = () => {
    setShowCreateTripLogModal(true);
  };

  const handleTripLogCreated = () => {
    setShowCreateTripLogModal(false);
    setTableRefreshKey((prev) => prev + 1);
  };

  return (
    <>
      <Table
        key={tableRefreshKey}
        tableFilterBoxFeatures={{
          showSearchBox: true,
          searchBoxPlaceholder: 'Search driver name...',
          rightAttr: [
            {
              type: 'regular',
              comp: <LogManagement />,
            },

            {
              type: 'regular',
              comp: (
                <FormSubmitButton
                  onClick={onSubmitCreateTripLog}
                  btnType='button'
                  className='fit large'
                >
                  Create Trip Log
                </FormSubmitButton>
              ),
            },
          ],
        }}
        tableHeader={{
          'Date Logged': 'createdAt',
          'Driver Name': 'driverName',
          'Customer email': 'customerEmail',
          'Date of trip': 'dateOfTrip',
        }}
        tableDataSourceUrl='api/v1/trip-logs'
        cellsCustomComp={{
          createdAt: <TableDateTimeFormatter dataKey='createdAt' />,
          dateOfTrip: <TableDateFormatter dataKey='dateOfTrip' />,
        }}
        mobileCellComp={<TripLogCell />}
      />
      <Modal
        showModal={showCreateTripLogModal}
        setShowModal={setShowCreateTripLogModal}
      >
        <TripLogModal onSuccess={handleTripLogCreated} />
      </Modal>
    </>
  );
};

export default TripLogTables;
